import React, { useEffect, useRef } from "react";
import MainContainer from "../components/containers/MainContainer";
import { default as Button2 } from "../components/Button/Button";
import BottomFloat2 from "../components/containers/BottomFloat2";
import TopBar from "../components/containers/TopBar";
import SingleText from "../components/Fields/SingleText";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import DeleteIcon from "@material-ui/icons/Delete";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Card from "@material-ui/core/Card";

import classnames from "classnames";
import Fab from "@material-ui/core/Fab";
import ListAltIcon from "@material-ui/icons/ListAlt";
import Zoom from "@material-ui/core/Zoom";
import Badge from "@material-ui/core/Badge";

import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import Global from "../assets/css/style";
import { Formik, Form, useFormikContext } from "formik";
import { computation4d, parseInt2, permuteCount } from "../utils/functions";
import { useSelector, useDispatch } from "react-redux";

import Container from "@material-ui/core/Container";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";

import { emptyThankYou } from "../redux/items/ThankYou";
import { emptyThankYouDetail } from "../redux/items/ThankYouDetails";
import Timer from "../components/Timer";
import t, { t2 } from "../Locale";
import ChooseBetPlace from "../components/ChooseBetPlace";
import DrawNo from "../components/DrawNo";
import NumberFormat from "react-number-format";
import LastSecond from "../components/LastSecond";
import { setFourDPrize } from "../redux/items/FourDPrize";
import { fourDPlaceBetSet } from "../redux/items/FourDPlaceBet";

import { computeAdd } from "../redux/items/FourDCompute";
import FetchNoLogin from "../components/Fetch/FetchNoLogin";
import { setDialogLogin } from "../redux/items/DialogLogin";

const useStyles = makeStyles((theme) => ({
	contentDrawDate: {
		padding: 24,
	},
	static: {
		position: "static",
	},
	label: {
		fontSize: 22,
		fontWeight: "bold",
		marginBottom: 6,
		marginTop: 8,
	},
	select: {
		backgroundColor: "#fff",
		border: "0.5px solid #C4C4C4",
		boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
		borderRadius: 42,
		padding: 10,
		fontSize: 24,
		width: "100%",
		marginTop: 10,
	},
	buttonGroup: {
		marginTop: 36,
	},
	buttonGroupInner: {
		backgroundColor: "#fff",
	},
	card: {
		marginTop: 32,
		marginBottom: -24,

		border: "0.5px solid #C4C4C4",
		boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
		borderRadius: 21,
	},
	selectionsBorder: {
		borderTop: "0.5px solid #C4C4C4",
		borderBottom: "0.5px solid #C4C4C4",
		borderRight: "0.5px solid #C4C4C4",
	},
	selectionsBorderRight: {
		borderRight: "0.5px solid #C4C4C4",
	},
	selectionsBorderNoRight: {
		borderRight: 0,
	},
	selectionsPad: {
		padding: "12px 24px",
	},
	fabWrapper: {
		position: "fixed",
		bottom: theme.spacing(1),
		maxWidth: theme.breakpoints.values.sm,
		width: "100%",
	},
	fab: {
		position: "absolute",
		bottom: theme.spacing(7),
		right: theme.spacing(3),
		backgroundColor: "green",
		color: "#fff",
		width: 88,
		height: 88,
		"& .MuiFab-label": {
			display: "flex",
			flexDirection: "column",
		},
	},

	button: {
		fontSize: 14,
	},
	formControl: {
		paddingTop: 0,
	},
}));

const default2 = {
	betType: "Ordinary",
	drawWeeks: [],
	board: [{ betSlip: ["", "", "", ""], big: 0, small: 0 }],
	total: 0,
};

const FormObserver = () => {
	const { values } = useFormikContext();
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(fourDPlaceBetSet(values));
		// eslint-disable-next-line
	}, [values]);
	return null;
};

const PlaceBet = () => {
	const classes = useStyles();
	const hist = useHistory();
	const dispatch = useDispatch();

	const [alertShow2, setAlertShow2] = React.useState(false);
	const [error, setError] = React.useState("");
	const [loading, setLoading] = React.useState(false);
	const language = useSelector((state) => state.Language);
	const login = useSelector((state) => state.login);

	const selectionRefs = useRef([]);
	selectionRefs.current = [];

	const fourDPrize = useSelector((state) => state.fourDPrize);
	const set = useSelector((state) => state.drawSet.set);

	const fourDCompute = useSelector((state) => state.fourDCompute);

	const fourDPlaceBet = useSelector((state) => state.fourDPlaceBet);
	const fourDDraw = useSelector((state) => state.drawSet.DrawFourD);

	const bottomRef = React.useRef(null);

	useEffect(() => {
		if (fourDPlaceBet.board?.length > 1)
			bottomRef.current?.scrollIntoView({ behavior: "smooth" });
		// eslint-disable-next-line
	}, []);

	const reqPrizeFourD = FetchNoLogin("prize-four-d", {
		callback: (cb) => {
			dispatch(setFourDPrize(cb.response.data.prize));
		},
	});

	const reqCheck4d = FetchNoLogin("check-4d", {
		callback: (cb) => {
			if (!cb.response.success)
				bottomRef.current?.scrollIntoView({ behavior: "smooth" });
		},
	});

	React.useEffect(() => {
		reqPrizeFourD.handleTrigger();

		dispatch(emptyThankYou());
		dispatch(emptyThankYouDetail());
		// eslint-disable-next-line
	}, []);

	const remove6Draw = (drawWeek = []) => {
		let index = drawWeek.indexOf("6 Draws");
		if (index > -1) {
			drawWeek.splice(index, 1);
		}
		return drawWeek;
	};

	const removeOtherWeek = (drawWeek = []) => {
		let index = drawWeek.indexOf("Wed");

		if (index > -1) {
			drawWeek.splice(index, 1);
		}

		let index2 = drawWeek.indexOf("Sat");
		if (index2 > -1) {
			drawWeek.splice(index2, 1);
		}

		let index3 = drawWeek.indexOf("Sun");
		if (index3 > -1) {
			drawWeek.splice(index3, 1);
		}
		return drawWeek;
	};

	const addSelectionRefs = (el) => {
		if (el && !selectionRefs.current.includes(el)) {
			selectionRefs.current.push(el);
		}
	};

	const computeStake = (form, betType = null, board, drawWeeks) => {
		betType = betType || form.values.betType;
		board = board || form.values.board;
		drawWeeks = drawWeeks || form.values.drawWeeks;

		let multi = drawWeeks.length;
		if (drawWeeks.indexOf("6 Draws") > -1) {
			multi = 6;
		}

		let tempTotal = 0;
		// prettier-ignore
		board.map((e) => {
      let tempTotal2 = 
        ((parseInt2(e.big) * set.bet_per_big) + 
        (parseInt2(e.small) * set.bet_per_small));
      if (betType === "System Entry") {
        tempTotal += tempTotal2 * permuteCount(e.betSlip) * multi;
      } else if (betType === "4D Roll") {
        tempTotal += tempTotal2 * 10 * multi;
      } else {
        tempTotal += tempTotal2 * multi;
      }
      return undefined;
    });

		setTimeout(() => {
			let tempTotal3 = parseFloat(tempTotal).toFixed(2);
			form.setFieldValue("total", tempTotal3);
		}, 0);
	};

	const renderSelected = (
		big = 0,
		small = 0,
		betType = "Original",
		betSlip
	) => {
		let multi_big = fourDPrize.ordinary_big;
		let multi_small = fourDPrize.ordinary_small;

		if (betType === "iBet") {
			let p = permuteCount(betSlip);
			if (p === 4 || p === 1) {
				multi_big = fourDPrize.ibet_big_triple;
				multi_small = fourDPrize.ibet_small_triple;
			} else if (p === 6) {
				multi_big = fourDPrize.ibet_big_2_pair;
				multi_small = fourDPrize.ibet_small_2_pair;
			} else if (p === 12) {
				multi_big = fourDPrize.ibet_big_1_pair;
				multi_small = fourDPrize.ibet_small_1_pair;
			} else if (p === 24) {
				multi_big = fourDPrize.ibet_big_all_unique;
				multi_small = fourDPrize.ibet_small_all_unique;
			}
		}
		return (
			<div style={{ width: "100%", textAlign: "center" }}>
				<div style={{ whiteSpace: "nowrap" }}>Potential 1st Prize:</div>
				<NumberFormat
					value={(big * multi_big + small * multi_small).toFixed(2)}
					displayType={"text"}
					thousandSeparator={true}
					prefix={"SGD "}
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						whiteSpace: "nowrap",
					}}
				/>
			</div>
		);
	};

	const computeProcessedData = async (placeBet) => {
		const compute = computation4d(placeBet, fourDDraw);
		dispatch(computeAdd(compute));
	};

	useEffect(() => {
		if (process.env.REACT_APP_YES_APP !== undefined) {
			if (login?.token === undefined) dispatch(setDialogLogin(true));
		}
		// eslint-disable-next-line
	}, []);

	return (
		<MainContainer
			loading={loading}
			render={
				<Grid container direction="column">
					<TopBar leftSide="/" title={t("4D Place Bet")} rightSide="">
						<Grid item container>
							<Grid item xs={8} className={classes.contentDrawDate}>
								<Typography>
									<b>{t("Draw Date")}:</b>
									<br />
									<Timer />
								</Typography>
							</Grid>
							<Grid
								item
								xs={4}
								className={classnames(
									classes.contentDrawDate,
									classes.contentDrawDateRight
								)}
							>
								<Typography>
									<b>{t("Draw No.")}</b>
									<br />
									<DrawNo />
								</Typography>
							</Grid>
						</Grid>
					</TopBar>
				</Grid>
			}
		>
			<div style={{ marginTop: -20, position: "relative" }}>
				<ChooseBetPlace select="4d" />
			</div>
			<Formik
				initialValues={
					JSON.stringify(fourDPlaceBet) !== "{}"
						? fourDPlaceBet
						: { ...default2 }
				}
			>
				{(form) => (
					<Form>
						<FormObserver />
						<LastSecond />
						<InputLabel className={classnames(classes.label)}>
							{t("Bet Type")}
						</InputLabel>
						<select
							className={classnames("styled-select")}
							onChange={(e) => {
								form.setFieldValue("betType", e.target.value);

								setAlertShow2(false);
								computeStake(form, e.target.value);
							}}
							value={form.values.betType}
						>
							<option value="Ordinary">{t("Ordinary")}</option>
							<option value="System Entry">{t("System Entry")}</option>
							<option value="iBet">{t("iBet")}</option>
							<option value="4D Roll">{t("4D Roll")}</option>
						</select>
						<Dialog
							open={alertShow2}
							onClose={() => {
								setAlertShow2(false);
								form.setFieldValue("betType", form.values.tempDatabetType);
							}}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description"
						>
							<DialogTitle id="alert-dialog-title">Are You Sure?</DialogTitle>
							<DialogContent>
								<DialogContentText id="alert-dialog-description">
									Changing the Bet Type will clear all the set Place Bet.
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<span
									onClick={() => {
										setAlertShow2(false);
									}}
									color="primary"
									style={{
										padding: "10px 20px",
										border: "1px solid #333",
										borderRadius: 8,
										backgroundColor: "green",
										color: "#fff",
										cursor: "pointer",
									}}
									className="noselect"
								>
									Disagree
								</span>
								<span
									onClick={() => {
										setAlertShow2(false);
									}}
									color="primary"
									autoFocus
									style={{
										padding: "10px 20px",
										border: "1px solid #333",
										borderRadius: 8,
										backgroundColor: "red",
										color: "#fff",
										cursor: "pointer",
									}}
									className="noselect"
								>
									Agree
								</span>
							</DialogActions>
						</Dialog>
						<FormControl fullWidth className={classes.formControl}>
							<InputLabel className={classnames(classes.static, classes.label)}>
								{t("Draw")}
							</InputLabel>
							<div className="buttongroup">
								<label
									className={classnames(classes.buttonGroupInner, "labelgroup")}
								>
									<input
										type="checkbox"
										onChange={(e) => {
											let w = [...form.values.drawWeeks];
											if (e.target.checked) {
												w.push("Wed");
												w = remove6Draw(w);
											} else {
												w.splice(w.indexOf("Wed"), 1);
											}
											form.setFieldValue("drawWeeks", w);

											computeStake(form, null, null, w);
										}}
										checked={form.values.drawWeeks.indexOf("Wed") > -1}
									/>
									<span>{t("Wed")}</span>
								</label>
								<label
									className={classnames(classes.buttonGroupInner, "labelgroup")}
								>
									<input
										type="checkbox"
										onChange={(e) => {
											let w = [...form.values.drawWeeks];
											if (e.target.checked) {
												w.push("Sat");
												w = remove6Draw(w);
											} else {
												w.splice(w.indexOf("Sat"), 1);
											}
											form.setFieldValue("drawWeeks", w);

											computeStake(form, null, null, w);
										}}
										checked={form.values.drawWeeks.indexOf("Sat") > -1}
									/>
									<span>{t("Sat")}</span>
								</label>
								<label
									className={classnames(classes.buttonGroupInner, "labelgroup")}
								>
									<input
										type="checkbox"
										onChange={(e) => {
											let w = [...form.values.drawWeeks];
											if (e.target.checked) {
												w.push("Sun");
												w = remove6Draw(w);
											} else {
												w.splice(w.indexOf("Sun"), 1);
											}
											form.setFieldValue("drawWeeks", w);

											computeStake(form, null, null, w);
										}}
										checked={form.values.drawWeeks.indexOf("Sun") > -1}
									/>
									<span>{t("Sun")}</span>
								</label>
								<label
									className={classnames(classes.buttonGroupInner, "labelgroup")}
								>
									<input
										type="checkbox"
										onChange={(e) => {
											let w = [...form.values.drawWeeks];
											if (e.target.checked) {
												w.push("6 Draws");
												w = removeOtherWeek(w);
											} else {
												w.splice(w.indexOf("6 Draws"), 1);
											}
											form.setFieldValue("drawWeeks", w);

											computeStake(form, null, null, w);
										}}
										checked={form.values.drawWeeks.indexOf("6 Draws") > -1}
									/>
									<span>{t("6 Draws")}</span>
								</label>
							</div>
						</FormControl>
						<FormControl fullWidth className={classes.formControl}>
							<InputLabel className={classnames(classes.static, classes.label)}>
								{t("Selections")}
							</InputLabel>

							<div
								style={{
									textAlign: "right",
									position: "absolute",
									width: "100%",
									marginTop: 32,
								}}
							>
								<span
									style={{
										color: Global.color,
										cursor: "pointer",
									}}
									onClick={() => {
										let boardDefault = [
											{
												betSlip: ["", "", "", ""],
												big: 0,
												small: 0,
											},
										];
										form.setFieldValue("board", boardDefault);

										computeStake(form, null, boardDefault);
									}}
								>
									{t("Clear All")}
								</span>
							</div>
							{form.values.board && form.values.board.length > 0
								? form.values.board.map((e, i) => (
										<Card className={classes.card} key={i}>
											<Grid container direction="column">
												<Grid item container>
													<Grid item xs={3} className={classes.selectionsPad}>
														<SwapHorizIcon
															style={{
																color: Global.color,
																fontSize: 48,
																cursor: "pointer",
															}}
															onClick={() => {
																let dArr = [
																	Math.floor(Math.random() * 10),
																	Math.floor(Math.random() * 10),
																	Math.floor(Math.random() * 10),
																	Math.floor(Math.random() * 10),
																];

																let board = [...form.values.board];
																board[i].betSlip = dArr;
																form.setFieldValue("board", board);

																computeStake(form);
															}}
														/>
													</Grid>
													<Grid
														item
														xs={6}
														className={classes.selectionsPad}
														style={{
															fontSize: 24,
															textAlign: "center",
															marginTop: 0,
														}}
													>
														<div>
															{t2("Board", language)} {i + 1}
														</div>
														<div
															style={{
																fontSize: 15,
																marginTop: -5,
																color: "#999",
															}}
														>
															{renderSelected(
																form.values.board[i].big,
																form.values.board[i].small,
																form.values.betType,
																form.values.board[i].betSlip
															)}
														</div>
													</Grid>
													<Grid
														item
														xs={3}
														className={classes.selectionsPad}
														style={{
															textAlign: "center",
														}}
													>
														{i > -1 ? (
															<DeleteIcon
																style={{
																	color: Global.defaultColor,
																	fontSize: 48,
																	cursor: "pointer",
																}}
																onClick={() => {
																	let l = [...form.values.board];
																	l.splice(i, 1);
																	form.setFieldValue("board", l);
																	let pos = (form.values.board.length - 1) * 4;
																	selectionRefs.current.splice(pos, 4);

																	computeStake(form, null, l);
																}}
															/>
														) : null}
													</Grid>
												</Grid>
												<Grid item container>
													<Grid
														item
														xs={3}
														className={classnames(classes.selectionsBorder)}
													>
														<SingleText
															t1={addSelectionRefs}
															selectionsRefs={selectionRefs}
															cursorX={0}
															cursorY={i}
															form={form}
															computeStake={computeStake}
														/>
													</Grid>
													<Grid
														item
														xs={3}
														className={classnames(classes.selectionsBorder)}
													>
														<SingleText
															t1={addSelectionRefs}
															selectionsRefs={selectionRefs}
															cursorX={1}
															cursorY={i}
															form={form}
															computeStake={computeStake}
														/>
													</Grid>
													<Grid
														item
														xs={3}
														className={classnames(classes.selectionsBorder)}
													>
														<SingleText
															t1={addSelectionRefs}
															selectionsRefs={selectionRefs}
															cursorX={2}
															cursorY={i}
															form={form}
															computeStake={computeStake}
														/>
													</Grid>
													<Grid
														item
														xs={3}
														className={classnames(
															classes.selectionsBorder,
															classes.selectionsBorderNoRight
														)}
													>
														<SingleText
															t1={addSelectionRefs}
															selectionsRefs={selectionRefs}
															cursorX={3}
															cursorY={i}
															form={form}
															computeStake={computeStake}
														/>
													</Grid>
												</Grid>
												<Grid
													item
													container
													style={{
														color: Global.color,
													}}
												>
													<Grid
														item
														xs={6}
														className={classnames(
															classes.selectionsBorderRight
														)}
													>
														<label
															style={{
																padding: 8,
																paddingLeft: 24,
																paddingBottom: 10,
																display: "block",
															}}
														>
															<Typography
																variant="subtitle1"
																style={{
																	fontSize: 12,
																	marginBottom: 4,
																}}
															>
																{t2("BIG", language)}
															</Typography>
															<Typography
																variant="h6"
																style={{
																	marginTop: -10,
																	fontSize: 20,
																}}
															>
																<Grid container>
																	<Grid item xs={1}>
																		${" "}
																	</Grid>
																	<Grid item xs={11}>
																		<input
																			type="number"
																			style={{
																				color: Global.color,
																				border: 0,
																				width: "100%",
																			}}
																			value={
																				isNaN(e.big) || e.big === undefined
																					? 0
																					: e.big
																			}
																			onChange={(f) => {
																				let board = [...form.values.board];

																				board[i].big = parseInt(f.target.value);

																				if (
																					board[i].big === null ||
																					board[i].big === undefined ||
																					isNaN(board[i].big)
																				)
																					board[i].big = 0;

																				f.target.value = board[i].big;

																				form.setFieldValue("board", board);

																				computeStake(form);
																			}}
																			ref={addSelectionRefs}
																		/>
																	</Grid>
																</Grid>
															</Typography>
														</label>
													</Grid>
													<Grid item xs={6}>
														<label
															style={{
																padding: 8,
																paddingLeft: 24,
																paddingBottom: 10,
																display: "block",
															}}
														>
															<Typography
																variant="subtitle1"
																style={{
																	fontSize: 12,
																	marginBottom: 4,
																}}
															>
																{t2("SMALL", language)}
															</Typography>
															<Typography
																variant="h6"
																style={{
																	marginTop: -10,
																	fontSize: 20,
																}}
															>
																<Grid container>
																	<Grid item xs={1}>
																		${" "}
																	</Grid>
																	<Grid item xs={11}>
																		<input
																			type="number"
																			style={{
																				color: Global.color,
																				border: 0,
																				width: "100%",
																			}}
																			value={
																				isNaN(e.small) || e.small === undefined
																					? 0
																					: e.small
																			}
																			onChange={(f) => {
																				let board = [...form.values.board];
																				board[i].small = parseInt(
																					f.target.value
																				);

																				if (
																					board[i].small === null ||
																					board[i].small === undefined ||
																					isNaN(board[i].small)
																				)
																					board[i].small = 0;

																				f.target.value = board[i].small;

																				form.setFieldValue("board", board);

																				computeStake(form);
																			}}
																		/>
																	</Grid>
																</Grid>
															</Typography>
														</label>
													</Grid>
												</Grid>
											</Grid>
										</Card>
								  ))
								: null}
						</FormControl>
						<Button2
							type="button"
							className={classes.button}
							onClick={() => {
								let v = [...form.values.board];
								let addData = {
									betSlip: ["", "", "", ""],
									big: 0,
									small: 0,
								};
								v.push(addData);

								form.setFieldValue("board", v);
							}}
							style={{ marginTop: 32 }}
						>
							{t("Add Board")}
						</Button2>

						<Typography
							dangerouslySetInnerHTML={{ __html: error }}
							style={{
								color: "red",
								textAlign: "center",
								paddingTop: 20,
								paddingBottom: 20,
							}}
						/>

						<BottomFloat2
							total={parseFloat(form.values.total)}
							onClick={async () => {
								setError("");
								setLoading(true);

								let ret2 = await reqCheck4d.handleTrigger({ ...fourDPlaceBet });
								let ret = ret2.response;

								if (!ret.success) {
									setError(ret.message);
									window.scroll(0, window.innerHeight * 2);
								} else {
									computeProcessedData({ ...fourDPlaceBet });

									form.setFieldValue("betType", default2.betType);
									form.setFieldValue("drawWeeks", default2.drawWeeks);
									form.setFieldValue("board", [
										{ betSlip: ["", "", "", ""], big: 0, small: 0 },
									]);
									form.setFieldValue("total", default2.total);
								}

								setLoading(false);
							}}
						/>
					</Form>
				)}
			</Formik>

			<Container className={classes.fabWrapper}>
				{fourDCompute.length > 0 && (
					<Zoom in className={classes.fab}>
						<Fab
							onClick={() => {
								hist.push("/personal-details");
							}}
						>
							<Badge badgeContent={fourDCompute.length} color="secondary">
								<ListAltIcon />
							</Badge>
							Bet Slip
						</Fab>
					</Zoom>
				)}
			</Container>
			<div ref={bottomRef} />
		</MainContainer>
	);
};

export default PlaceBet;
